// extracted by mini-css-extract-plugin
export default {"root":"textarea_root__b0n1I","is-invalid":"textarea_is-invalid__viLH2","border":"textarea_border__g9WIo"};